module.exports = __webpack_public_path__ + "static/media/Android.7f3a4054.png";